import { createContext } from 'react'
import { Timeline } from 'utils/__generated__/graphql'

export type TimelineContextType = {
  timeline: Timeline
}

const TimelineContext = createContext({} as TimelineContextType)

export default TimelineContext
